import { Link } from 'react-router-dom'

export default function About() {
  return (
    <div className="section max-w-3xl prose prose-slate">
      <h1 className="font-display text-3xl text-civitas-navy mb-3">About BECivitas</h1>

      <div className="card mb-6">
        <p className="text-civitas-silver leading-relaxed">
          BECivitas is a non-partisan civic technology project piloting in Virginia and Delaware for the
          November 2026 General Election. Our mission is to provide voters with transparent, verifiable,
          and non-partisan information — allowing them to understand candidate alignment with their personal
          beliefs, free from ideological spin.
        </p>
      </div>

      <h2 className="font-display text-xl text-civitas-navy mt-8 mb-3">Our Mission</h2>
      <p className="text-civitas-silver mb-4">
        Democracy works best when voters have access to accurate, unbiased information about the candidates
        on their ballot. Too often, civic information is filtered through media narratives, campaign advertising,
        or partisan framing that makes it difficult to understand what candidates actually believe and how they
        have actually voted.
      </p>
      <p className="text-civitas-silver mb-4">
        BECivitas uses a data-first approach — pulling from official legislative records, campaign finance
        filings, and verified public statements — to build candidate profiles that reflect reality rather
        than talking points.
      </p>

      <h2 className="font-display text-xl text-civitas-navy mt-8 mb-3">The 2026 Pilot</h2>
      <p className="text-civitas-silver mb-4">
        This pilot covers Virginia and Delaware state legislative and federal races for November 2026.
        We are tracking 10 candidates across 4 districts in two states. Candidate data is manually verified
        and sourced from official records.
      </p>

      <h2 className="font-display text-xl text-civitas-navy mt-8 mb-3">Business Model</h2>
      <p className="text-civitas-silver mb-4">
        Core matching features are free for all voters. Our sustainability model includes:
      </p>
      <ul className="text-civitas-silver space-y-2 mb-4 list-disc list-inside">
        <li><strong>B2B:</strong> Anonymized, aggregated District Sentiment Reports sold to non-partisan research groups</li>
        <li><strong>Pro Tier:</strong> Custom legislative alerts and Influence Map deep-dives for engaged voters</li>
      </ul>
      <p className="text-civitas-silver text-sm">
        Individual political data is never sold. Our B2B reports use only anonymized, aggregated data that
        cannot be traced to individual users.
      </p>

      <div className="mt-8 flex gap-3 flex-wrap">
        <Link to="/how-it-works" className="btn-primary">How It Works</Link>
        <Link to="/privacy" className="btn-secondary">Privacy Policy</Link>
        <Link to="/feedback" className="btn-secondary">Contact Us</Link>
      </div>
    </div>
  )
}
